import axios, { type AxiosResponse } from "axios";
import { FeedbackProductItemSchema } from "@/schemas/feedback/feedback-product-item";
import type { FeedbackProductItemType } from "@/schemas/feedback/feedback-product-item";
import env from "@/app/config/env";

export interface ServiceFeedbackApiType {
  fetchProductReviews: (
    productId: string,
  ) => Promise<FeedbackProductItemType[]>;
  createProductReview: (
    review: FeedbackProductItemType,
  ) => Promise<FeedbackProductItemType>;
}

export const serviceFeedbackApi: ServiceFeedbackApiType = {
  fetchProductReviews: (productId) => {
    return axios
      .get(`${env.services.portal}/products/${productId}/reviews`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response.data?.map((record: unknown) =>
            FeedbackProductItemSchema.parse(record),
          ) || []
        );
      });
  },
  createProductReview: (review) => {
    return axios.post(`${env.services.portal}/feedback/product`, review);
  },
};
